export type HomepageHeroCTALinks = {
  getStarted: string;
  exploreComponents: string;
}

export const homepageHeroCTALinks: HomepageHeroCTALinks = {
  getStarted: "/guides/getting_started",
  exploreComponents: "/kits",
}
